import OutlineBox from "../../../UI/OutlineBox/OutlineBox";
import {Box, Button, Grid, useMediaQuery} from "@mui/material";
import {fnLocalizeFilter} from "../../../../services/localize.service";
import DatePicker from "../../../UI/DatePicker/DatePicker";
import moment from "moment";
import React, {useCallback, useEffect, useMemo, useState} from "react";
import {getMedia} from "../../../../helpers/media";
import {useGlobalContext} from "../../../../services/context.service";
import ComboBox from "../../../UI/Input/ComboBox";
import {getColumns} from "./certificatesOfWorkPerformed.columns";
import CustomTable from "../../../UI/CustomTable";
import {REPORT_COUNT_PER_ON_PAGE} from "../../../../helpers/api";
import {IFilter, ISingleRow} from "../../../UI/CustomTable/interface/interface.custom";
import {getDownloadFile} from "../../../../helpers/common";
import {documentsAPI} from "../../../../services/documents.service";
import {holderAPI} from "../../../../services/holderAPI.service";
import {IHolders} from "../../../../services/response.interface";

/* Кол-во строк в таблице счетов, на странице инфо клиента */
const countPerOnPage: number = REPORT_COUNT_PER_ON_PAGE ? +REPORT_COUNT_PER_ON_PAGE : 5;

interface IFilterLocalState {
    fromDate: string;
    toDate: string;
    holderId: number;
    page: number;
    limit: number;
}

const initialStateFilter = {
    fromDate: moment().format('YYYY-MM-01'),
    toDate: moment().format('YYYY-MM-DD'),
    holderId: -1,
    page: 0,
    limit: countPerOnPage
};

const listOfKindDocuments = [{id: 1, docName: 'Акт прийому-передачі'}];

export default function CertificatesOfWorkPerformed() {
    /* Получаем языковую локаль */
    const {locale} = useGlobalContext();
    /* Инициализация медиа  */
    const matches = useMediaQuery(getMedia());

    /* Получаем список клиентов доступных пользователю */
    const {data: dataHolder = {holders: []}} = holderAPI.useFetchAllClientsQuery({locale});

    const [holder, setHolder] = useState<IHolders>();

    useEffect(() => {
        if (dataHolder.holders.length > 0) {
            setHolder(dataHolder.holders[0]);
            setFilterState(prev => ({
                ...prev, holderId: dataHolder.holders[0].holderId
            }))
        }
    }, [dataHolder.holders]);

    const handleChangeClient = (holderId: number) => {
        setFilterState(prev => ({...prev, holderId}))
    };

    const [filter, setFilterState] = useState<IFilterLocalState>(initialStateFilter);

    const [getDocuments, {
        data: dataDocs = {docs: [], countOfRows: countPerOnPage}, isLoading: isLoadingDocs,
    }] = documentsAPI.useLazyFetchAllDocumentsQuery();

    useEffect(() => {
        dataHolder.holders.length > 0 && getDocuments({
            locale, ...filter, holderId: holder && holder.holderId || dataHolder.holders[0].holderId
        })
    }, [holder])


    const handleChangeRangeOfDate = (rangeDate: any) => {
        setFilterState(prev => ({
            ...prev,
            fromDate: moment(rangeDate[0]).format('YYYY-MM-DD'),
            toDate: moment(rangeDate[1]).format('YYYY-MM-DD')
        }))
    };

    const dateTimePicker = useMemo(() => {

        const dateStart = moment(filter.fromDate).format('YYYY-MM-DD');
        const dateEnd = moment(filter.toDate).format('YYYY-MM-DD');

        let picker: [string, string] = [dateStart, dateEnd]

        return picker;

    }, [filter])

    const handleCommitFilter = useCallback(() => {
        getDocuments({locale, ...filter})
    }, [filter, locale]);

    /* Текущая страница счетов */
    const handleChangePage = ({page, orderBy}: IFilter) => {

        let customFilter = filter.holderId === -1 ? {
            ...filter, holderId: dataHolder.holders[0]?.holderId
        } : {...filter}

        getDocuments({
            locale, ...customFilter, page: page - 1, limit: countPerOnPage
        })
    };

    const handleDownloadFile = async ({row}: ISingleRow) => {
        const fileName = row.fileName ? row.fileName : moment().format('YYYYMMDDHHmmss');
        await getDownloadFile({
            method: 'get', url: `/common/docs/${row.id}/file`, params: {}, fileNameToSave: `${fileName}`
        })
    };

    /* Заполняем табличные заголовки */
    const columns = useMemo(() => {
        return getColumns({locale, onDownloadFileExcel: handleDownloadFile});
    }, [locale, handleDownloadFile]);

    /* Фильтр по столбцам таблицы  */
    const rows = useMemo(() => {
        let count = 10;
        let filteredArr: any[] = dataDocs.docs;

        return {arr: filteredArr, count};
    }, [dataDocs]);


    /*
    *  Тип документа
    * {
                        <ComboBox
                        textStyle={{fontWeight: '700'}}
                        data={listOfKindDocuments}
                        fieldLabelOption={'docName'}
                        label={fnLocalizeFilter(locale, '_lang.module.reports.titleTrnKind')}
                        fnOnChange={handleChangeKinds}
                        callbackType={'fullData'}
                        defaultValue={filter.docType}
                    />
                    }
    *
    * */

    return <Box style={{maxWidth: `${matches ? '100%' : '60%'}`}}>
        <OutlineBox>
            <Grid container style={{display: "flex", alignItems: "center", justifyContent: 'flex-start'}}>

                <Grid item xs={12} md={5}>
                    <ComboBox
                        textStyle={{fontWeight: '700'}}
                        data={dataHolder.holders}
                        fieldLabelOption={'name'}
                        label={fnLocalizeFilter(locale, '_lang.module.common.title.titleClientComboBox')}
                        fnOnChange={handleChangeClient}

                    />
                </Grid>
                <Grid item xs={12} md={5}>
                    <DatePicker
                        onChange={handleChangeRangeOfDate}
                        pickerValue={dateTimePicker}
                    />
                </Grid>
                <Grid item xs={12} md={2} textAlign={'center'}>
                    <Button
                        color={'secondary'}
                        sx={{
                            fontSize: '.8rem', justifySelf: 'center',
                        }}
                        onClick={handleCommitFilter}
                    >
                        {fnLocalizeFilter(locale, "_lang.module.common.title.titleExecute")}
                    </Button>
                </Grid>

            </Grid>
        </OutlineBox>
        <Grid item xs={12}>
            <CustomTable
                rows={rows.arr}
                columns={columns}
                isLoading={isLoadingDocs}
                count={dataDocs.countOfRows}
                labelEmptyRows={fnLocalizeFilter(locale, '_lang.module.common.table.emptyRows')}
                rowsPerPageOptions={[countPerOnPage]}
                fnRefreshData={handleChangePage}

            />
        </Grid>
    </Box>
}
